import { updateDialog } from '@Containers/Dialogs/DialogsActions';

import { typeOfFilterByValueConfirmDialog } from './FilterByValueConfirmDialogConstants';

// eslint-disable-next-line import/prefer-default-export
export function open(filterId) {
  return updateDialog({
    filterId,
    id: typeOfFilterByValueConfirmDialog,
    movable: false,
    size: 'md',
    dialogType: typeOfFilterByValueConfirmDialog,
  });
}
